import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {AppState} from "@store/reducers";
import {Store} from "@ngrx/store";
import {ModalDataRemove} from "@store/actions";

interface DialogSharedModal {
  bodyModalText?: string;
  bodyText?: string;
  errorType?: {
    dimensions: boolean,
    route: boolean,
  };
  error: boolean;
  id: string;
  header: string;
  removeShow: boolean;
  showCancel: boolean;
  showOk: boolean;
}

@Component({
  selector: 'app-shared-dialog-modal',
  template: `
  <div mat-dialog-content>
      <p *ngIf="content" > <span [innerHTML]="content" translate></span>{{data.id}}</p>
    <p *ngIf="errorShow"> {{header | translate}} </p>
    <p *ngIf="contentShow" [translate]="bodyText.text"
    [translateParams]="{shipments: bodyText.param.shipments, created: bodyText.param.created }"></p>
  </div>
  <div mat-dialog-actions>
    <button class="app-shared-dialog-yes" *ngIf="contentShow" mat-button (click)="onNoClick('true')" cdkFocusInitial>Yes</button>
    <button class="app-shared-dialog-yes" *ngIf="showOk" mat-button (click)="onNoClick('true')" cdkFocusInitial>Ok</button>
    <button class="app-shared-dialog-yes" *ngIf="removeShow" mat-button (click)="onNoClick('true')" cdkFocusInitial>Yes, delete</button>
    <button class="app-shared-dialog-no" *ngIf="showCancel" mat-button (click)="onNoClick('false')">Cancel</button>
  </div>`,
})

export class DialogSharedComponent implements OnInit {
  errorType: string;
  header: string;
  content: string;
  bodyText: string;
  removeShow =  false;
  errorShow =  false;
  contentShow =  false;
  showCancel = true;
  showOk = false;

  constructor(
    public dialogRef: MatDialogRef<DialogSharedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogSharedModal,
    private store: Store<AppState>,
  ) {}

  ngOnInit() {
    if (this.data && this.data.bodyModalText) {
      this.content = this.data.bodyModalText;
      this.removeShow = true;
    } else if (this.data && this.data.errorType) {
      this.content = this.header;
    }
    if (this.data.errorType) {
      this.errorShow = true;
    }
    if (this.data.header) {
      this.header = this.data.header;
    }
    if (this.data.bodyText) {
      this.bodyText = this.data.bodyText;
      this.contentShow = true;
    }
    this.removeShow = this.data.hasOwnProperty('removeShow') ? this.data.removeShow : true;
    this.showCancel = this.data.hasOwnProperty('showCancel') ? this.data.showCancel : true;
    this.showOk = this.data.hasOwnProperty('showOk') ? this.data.showOk : false;
  }

  onNoClick(param) {
    this.dialogRef.close(param);
    this.store.dispatch(new ModalDataRemove());
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dialog-shared/dialog-shared.component.ts